export const expertsCurrentPageTypes = {
  SET_CURRENT_PAGE: 'EXPERTS_SET_CURRENT_PAGE',
};
export const getExpertsTypes = {
  REQUEST: 'EXPERT_GET_LIST_REQUEST',
  SUCCESS: 'EXPERT_GET_LIST_SUCCESS',
  FAILED: 'EXPERT_GET_LIST_FAILED',
};
